(function () {
  'use strict';

  var atlas = document.getElementById('tpl-color-atlas');
  if (!atlas) return;

  var raw = window.TPL_COLOR_DATA;

  var field = document.getElementById('tpl-atlas-field');
  var viewport = document.getElementById('tpl-atlas-viewport');
  var searchInput = document.getElementById('tpl-atlas-search');
  var statusEl = document.getElementById('tpl-atlas-status');
  var emptyEl = document.getElementById('tpl-atlas-empty');
  var tooltip = document.getElementById('tpl-atlas-tooltip');

  var selection = document.getElementById('tpl-atlas-selection');
  var selectionSwatch = document.getElementById('tpl-atlas-selection-swatch');
  var selectionName = document.getElementById('tpl-atlas-selection-name');
  var selectionCollection = document.getElementById('tpl-atlas-selection-collection');
  var selectionLink = document.getElementById('tpl-atlas-selection-link');
  var selectionClose = document.getElementById('tpl-atlas-selection-close');

  var preview = document.getElementById('tpl-atlas-preview');
  var previewCard = preview
    ? preview.querySelector('.tpl-atlas__preview-card')
    : null;

  var previewImage = document.getElementById('tpl-atlas-preview-image');
  var previewName = document.getElementById('tpl-atlas-preview-name');
  var previewCollection = document.getElementById('tpl-atlas-preview-collection');
  var previewLink = document.getElementById('tpl-atlas-preview-link');
  var previewClose = document.getElementById('tpl-atlas-preview-close');

  var tabButtons = Array.prototype.slice.call(
    atlas.querySelectorAll('[data-atlas-tab]')
  );

  var activeCollection = 'general';
  var selectedKey = '';
  var allColors = [];
  var lastFocusedSwatch = null;

  /*
    Two consecutive families are stacked
    vertically in each General Collection column.
  */
  var GENERAL_FAMILY_ORDER = [
    'LILAC', 'IRIS',
    'MIST', 'AUBEGINE',
    'GRANITE', 'FOG',
    'LICHEN', 'MARBLE',
    'ASH', 'FOSSIL',
    'TEAK', 'MAHAGONY',
    'CEDAR', 'CHOCOLATE',
    'WALNUT', 'DESERT',
    'BRICK', 'PIETRA',
    'UMBER', 'RUSSET',
    'MUSHROOM', 'CANYON',
    'TRUFFLE', 'MAPLE',
    'LINEN', 'BEECH',
    'KHAKI', 'CHAMOIS',
    'SAND', 'SADDLE',
    'HEMP', 'OCHRE',
    'TAUPE', 'SAGUARO',
    'DRIFTWOOD', 'TOBACCO',
    'LMESTONE', 'MOSS',
    'CASCADE', 'JAVA',
    'CEMENT', 'CELADON',
    'SLATE', 'OCEAN',
    'COASTAL', 'ASPHALT',
    'SEA', 'SIENNA',
    'TEAL', 'MESA'
  ];

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[_\-+/]+/g, ' ')
      .replace(/[^a-z0-9&]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function collectionLabel(canonical) {
    if (canonical === 'neutral') {
      return 'Whites + Blacks';
    }

    if (canonical === 'vivid') {
      return 'Vivids';
    }

    if (canonical === 'metals') {
      return 'Metals';
    }

    if (canonical === 'patina') {
      return 'Patina';
    }

    return 'General Collection';
  }

  function destinationFor(color) {
    if (color.canonical === 'metals') {
      return '/products/metallic';
    }

    if (color.canonical === 'patina') {
      return '/products/patina-kit';
    }

    return '/collections/samples';
  }

  function buildLibrary() {
    var colors = [];

    [
      'general',
      'neutral',
      'vivid',
      'metals',
      'patina'
    ].forEach(function (canonical) {
      var list = raw[canonical] || [];

      list.forEach(function (item) {
        colors.push({
          name: item.name || '',
          family: item.family || '',
          value: item.value || null,
          canonical: canonical,
          image: item.image || '',
          color: item.color || ''
        });
      });
    });

    return colors;
  }

  function colorKey(color) {
    return (
      color.canonical +
      '|' +
      normalize(color.name)
    );
  }

  function applyVisual(element, color) {
    if (!element) {
      return;
    }

    element.style.backgroundColor =
      color.color || '#dedbd4';

    element.style.backgroundImage =
      color.image
        ? 'url("' +
          color.image.replace(/"/g, '\\"') +
          '")'
        : 'none';
  }

  function colorsFor(canonical) {
    return allColors.filter(function (color) {
      return color.canonical === canonical;
    });
  }

  function setActiveTab(canonical) {
    activeCollection = canonical;

    tabButtons.forEach(function (button) {
      var active =
        button.dataset.atlasTab === canonical;

      button.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );

      button.classList.toggle(
        'is-active',
        active
      );
    });
  }

  function matchesQuery(color, query) {
    if (!query) {
      return true;
    }

    return (
      normalize(color.name).indexOf(query) !== -1 ||
      normalize(color.family).indexOf(query) !== -1 ||
      normalize(
        collectionLabel(color.canonical)
      ).indexOf(query) !== -1
    );
  }

  function findFirstMatchingCollection(query) {
    var order = [
      'general',
      'neutral',
      'vivid',
      'metals',
      'patina'
    ];

    for (
      var i = 0;
      i < order.length;
      i += 1
    ) {
      var canonical = order[i];

      var found =
        colorsFor(canonical).some(
          function (color) {
            return matchesQuery(
              color,
              query
            );
          }
        );

      if (found) {
        return canonical;
      }
    }

    return '';
  }

  function showTooltip(color, button) {
    if (!tooltip) {
      return;
    }

    if (
      window.matchMedia &&
      window.matchMedia(
        '(hover: none), (pointer: coarse)'
      ).matches
    ) {
      return;
    }

    tooltip.textContent = color.name;

    tooltip.classList.add(
      'is-visible'
    );

    var rect =
      button.getBoundingClientRect();

    var tipRect =
      tooltip.getBoundingClientRect();

    var left =
      rect.left +
      rect.width / 2 -
      tipRect.width / 2;

    var top =
      rect.top -
      tipRect.height -
      13;

    left = Math.max(
      10,
      Math.min(
        window.innerWidth -
          tipRect.width -
          10,
        left
      )
    );

    if (top < 10) {
      top =
        rect.bottom + 13;
    }

    tooltip.style.left =
      Math.round(left) + 'px';

    tooltip.style.top =
      Math.round(top) + 'px';
  }

  function hideTooltip() {
    if (!tooltip) {
      return;
    }

    tooltip.classList.remove(
      'is-visible'
    );
  }

  /*
    Replace the small thumbnail request
    with a 1200px Shopify CDN request
    when a color is clicked.
  */
  function largeImageUrl(url) {
    if (!url) {
      return '';
    }

    try {
      var parsed =
        new URL(
          url,
          window.location.origin
        );

      parsed.searchParams.set(
        'width',
        '1200'
      );

      return parsed.toString();
    } catch (error) {
      if (
        /([?&])width=\d+/i.test(url)
      ) {
        return url.replace(
          /([?&])width=\d+/i,
          '$1width=1200'
        );
      }

      return (
        url +
        (
          url.indexOf('?') === -1
            ? '?'
            : '&'
        ) +
        'width=1200'
      );
    }
  }

  function updateActionLinks(color) {
    var href =
      destinationFor(color);

    if (selectionLink) {
      selectionLink.href = href;
      selectionLink.textContent =
        'Buy sample';
    }

    if (previewLink) {
      previewLink.href = href;
      previewLink.textContent =
        'Buy sample';
    }
  }

  function showLargePreview(
    color,
    sourceButton
  ) {
    if (
      !preview ||
      !previewImage
    ) {
      return;
    }

    lastFocusedSwatch =
      sourceButton ||
      document.activeElement;

    previewName.textContent =
      color.name;

    previewCollection.textContent =
      collectionLabel(
        color.canonical
      );

    previewImage.alt =
      color.name;

    updateActionLinks(color);

    if (color.image) {
      previewImage.src =
        largeImageUrl(
          color.image
        );

      previewImage.style.display =
        'block';

      previewImage.style.backgroundColor =
        '';
    } else {
      previewImage.removeAttribute(
        'src'
      );

      previewImage.style.display =
        'block';

      previewImage.style.backgroundColor =
        color.color || '#dedbd4';
    }

    preview.classList.add(
      'is-visible'
    );

    preview.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'tpl-atlas-preview-open'
    );

    window.setTimeout(
      function () {
        if (previewClose) {
          previewClose.focus();
        }
      },
      0
    );
  }

  function hideLargePreview() {
    if (!preview) {
      return;
    }

    preview.classList.remove(
      'is-visible'
    );

    preview.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'tpl-atlas-preview-open'
    );

    if (
      lastFocusedSwatch &&
      typeof lastFocusedSwatch.focus ===
        'function'
    ) {
      lastFocusedSwatch.focus({
        preventScroll: true
      });
    }
  }

  function selectColor(
    color,
    button
  ) {
    selectedKey =
      colorKey(color);

    Array.prototype.forEach.call(
      field.querySelectorAll(
        '.tpl-atlas__swatch'
      ),
      function (node) {
        node.classList.toggle(
          'is-selected',
          node === button
        );
      }
    );

    applyVisual(
      selectionSwatch,
      color
    );

    selectionName.textContent =
      color.name;

    selectionCollection.textContent =
      collectionLabel(
        color.canonical
      );

    updateActionLinks(color);

    if (selection) {
      selection.classList.add(
        'is-visible'
      );
    }

    showLargePreview(
      color,
      button
    );
  }

  function clearSelection() {
    selectedKey = '';

    if (selection) {
      selection.classList.remove(
        'is-visible'
      );
    }

    Array.prototype.forEach.call(
      field.querySelectorAll(
        '.tpl-atlas__swatch'
      ),
      function (node) {
        node.classList.remove(
          'is-selected'
        );
      }
    );
  }

  function makeSwatch(
    color,
    query
  ) {
    var button =
      document.createElement(
        'button'
      );

    button.type =
      'button';

    button.className =
      'tpl-atlas__swatch';

    button.dataset.colorKey =
      colorKey(color);

    button.setAttribute(
      'aria-label',
      color.name +
        ', ' +
        collectionLabel(
          color.canonical
        )
    );

    applyVisual(
      button,
      color
    );

    if (
      query &&
      matchesQuery(
        color,
        query
      )
    ) {
      button.classList.add(
        'is-search-match'
      );
    }

    if (
      selectedKey ===
      colorKey(color)
    ) {
      button.classList.add(
        'is-selected'
      );
    }

    button.addEventListener(
      'mouseenter',
      function () {
        showTooltip(
          color,
          button
        );
      }
    );

    button.addEventListener(
      'mouseleave',
      hideTooltip
    );

    button.addEventListener(
      'focus',
      function () {
        showTooltip(
          color,
          button
        );
      }
    );

    button.addEventListener(
      'blur',
      hideTooltip
    );

    button.addEventListener(
      'click',
      function () {
        hideTooltip();

        selectColor(
          color,
          button
        );
      }
    );

    return button;
  }

  function renderGeneral(
    colors,
    query
  ) {
    var wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      'tpl-atlas__general';

    var byFamily =
      Object.create(null);

    colors.forEach(
      function (color) {
        var family =
          color.family ||
          color.name.replace(
            /\s+[1-8]$/,
            ''
          );

        if (!byFamily[family]) {
          byFamily[family] = [];
        }

        byFamily[family].push(
          color
        );
      }
    );

    Object.keys(
      byFamily
    ).forEach(
      function (family) {
        byFamily[family].sort(
          function (a, b) {
            return (
              (a.value || 0) -
              (b.value || 0)
            );
          }
        );
      }
    );

    var families =
      GENERAL_FAMILY_ORDER.filter(
        function (family) {
          return !!byFamily[family];
        }
      );

    Object.keys(
      byFamily
    ).forEach(
      function (family) {
        if (
          families.indexOf(
            family
          ) === -1
        ) {
          families.push(
            family
          );
        }
      }
    );

    for (
      var i = 0;
      i < families.length;
      i += 2
    ) {
      var pair =
        document.createElement(
          'div'
        );

      pair.className =
        'tpl-atlas__pair';

      [
        families[i],
        families[i + 1]
      ].forEach(
        function (family) {
          if (!family) {
            return;
          }

          var familyEl =
            document.createElement(
              'div'
            );

          familyEl.className =
            'tpl-atlas__family';

          familyEl.setAttribute(
            'aria-label',
            family +
              ' values 1 through 8'
          );

          byFamily[
            family
          ].forEach(
            function (color) {
              familyEl.appendChild(
                makeSwatch(
                  color,
                  query
                )
              );
            }
          );

          pair.appendChild(
            familyEl
          );
        }
      );

      wrapper.appendChild(
        pair
      );
    }

    return wrapper;
  }

  function renderDense(
    colors,
    query,
    canonical
  ) {
    var wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      'tpl-atlas__dense ' +
      'tpl-atlas__dense--' +
      canonical;

    colors.forEach(
      function (color) {
        wrapper.appendChild(
          makeSwatch(
            color,
            query
          )
        );
      }
    );

    return wrapper;
  }

  function render() {
    var query =
      normalize(
        searchInput
          ? searchInput.value
          : ''
      );

    atlas.classList.toggle(
      'is-searching',
      !!query
    );

    /*
      If the current collection has no
      match, move to the first collection
      that does.
    */
    if (query) {
      var activeHasMatch =
        colorsFor(
          activeCollection
        ).some(
          function (color) {
            return matchesQuery(
              color,
              query
            );
          }
        );

      if (!activeHasMatch) {
        var target =
          findFirstMatchingCollection(
            query
          );

        if (target) {
          setActiveTab(target);
        }
      }
    }

    var colors =
      colorsFor(
        activeCollection
      );

    var anyMatch =
      !query ||
      colors.some(
        function (color) {
          return matchesQuery(
            color,
            query
          );
        }
      );

    field.innerHTML = '';

    if (emptyEl) {
      emptyEl.classList.toggle(
        'is-visible',
        !anyMatch
      );
    }

    field.appendChild(
      activeCollection ===
        'general'
        ? renderGeneral(
            colors,
            query
          )
        : renderDense(
            colors,
            query,
            activeCollection
          )
    );

    if (statusEl) {
      statusEl.textContent = '';
      statusEl.hidden = true;
    }

    if (viewport) {
      viewport.scrollLeft = 0;
    }
  }

  function fail(message) {
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent =
        message;
    }

    if (field) {
      field.innerHTML = '';
    }
  }

  /*
    DATA CHECK
  */
  if (
    !raw ||
    !Array.isArray(
      raw.general
    ) ||
    !raw.general.length
  ) {
    fail(
      'Color library unavailable.'
    );

    return;
  }

  allColors =
    buildLibrary();

  /*
    COLLECTION TABS
  */
  tabButtons.forEach(
    function (button) {
      button.addEventListener(
        'click',
        function () {
          setActiveTab(
            button.dataset.atlasTab
          );

          render();
        }
      );
    }
  );

  /*
    SEARCH
  */
  if (searchInput) {
    searchInput.addEventListener(
      'input',
      render
    );
  }

  /*
    SELECTED BAR CLOSE
  */
  if (selectionClose) {
    selectionClose.addEventListener(
      'click',
      clearSelection
    );
  }

  /*
    LARGE PREVIEW CLOSE
  */
  if (previewClose) {
    previewClose.addEventListener(
      'click',
      hideLargePreview
    );
  }

  /*
    Clicking dark backdrop closes preview.
  */
  if (preview) {
    preview.addEventListener(
      'click',
      function (event) {
        if (
          event.target === preview
        ) {
          hideLargePreview();
        }
      }
    );
  }

  /*
    Clicking the card itself does not
    close the modal.
  */
  if (previewCard) {
    previewCard.addEventListener(
      'click',
      function (event) {
        event.stopPropagation();
      }
    );
  }

  /*
    Escape closes preview.
  */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        preview &&
        preview.classList.contains(
          'is-visible'
        )
      ) {
        hideLargePreview();
      }
    }
  );

  document.addEventListener(
    'scroll',
    hideTooltip,
    true
  );

  window.addEventListener(
    'resize',
    hideTooltip
  );

  setActiveTab(
    'general'
  );

  render();
})();